<button [class]="classes" type="button" [disabled]="disabled" (click)="onClick()">
  @if (isSsoLogin) {
    <span>Entrar com</span>
    <span class="ml-1 text-bold">SSO</span>
  }@else {
    @if (icon) {
      <i class="fas {{icon}} mr-1" aria-hidden="true"></i>
    }
    {{ label }}
  }
</button>
